import { TFunction } from 'i18next';

import { InstalmentType } from 'src/shared/enum/InstalmentType';

export function createLabelFromInstalmentType(instalmentName: string, t: TFunction): string {
    if (instalmentName.includes(InstalmentType.BESPOKE)) {
        return t('booking_summary_bespoke_instalment_plan');
    }

    switch (instalmentName) {
        case InstalmentType.ANNUAL:
            return t('booking_summary_annual_instalment_plan');
        case InstalmentType.INSTALMENTS_2:
            return t('booking_summary_instalments', { count: 2 });
        case InstalmentType.INSTALMENTS_3:
            return t('booking_summary_instalments', { count: 3 });
        case InstalmentType.INSTALMENTS_4:
            return t('booking_summary_instalments', { count: 4 });
        case InstalmentType.INSTALMENTS_10:
            return t('booking_summary_instalments', { count: 10 });
        case InstalmentType.INSTALMENTS_12:
            return t('booking_summary_instalments', { count: 12 });
        case InstalmentType.MONTHLY:
            return t('booking_summary_monthly_instalment_plan');
        case InstalmentType.BESPOKE:
            return t('booking_summary_bespoke_instalment_plan');
        default:
            throw new Error(`Unsupported instalment type: ${instalmentName}`);
    }
}
